import { module }from 'stereomodularjs';
import { html } from '../utils/environment'
import { createApp } from "vue/dist/vue.esm-bundler.js"
import PersonnesRessources from '../components/PersonnesRessources.vue'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;

        const app = createApp({
            template: '<PersonnesRessources />',
            components: {
                PersonnesRessources
            },
            data() {
                return {
                }
            },
            mounted() {
            },
        })
        app.config.globalProperties.personnesRessources = personnesRessources;
        app.mount(self.el);
    }
}
